import { FunctionComponent } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { IndexPage } from './pages/IndexPage';
import { PersonasOverviewPage } from './pages/PersonasOverviewPage';
import { AliasesManagementPage } from './pages/AliasesManagementPage';
import { MessagesStatisticsPage } from './pages/MessagesStatisticsPage';
import { TagsManagementPage } from './pages/TagsManagementPage';
import { ContactsOverviewPage } from './pages/ContactsOverviewPage';

export const AdministrationLayout: FunctionComponent = () => {
    return (
        <Routes>
            <Route index element={<IndexPage />} />
            <Route path="personas" element={<PersonasOverviewPage />} />
            <Route path="aliases" element={<AliasesManagementPage />} />
            <Route path="messages" element={<MessagesStatisticsPage />} />
            <Route path="tags" element={<TagsManagementPage />} />
            <Route path="contacts" element={<ContactsOverviewPage />} />
            <Route path="*" element={<Navigate to="/administration" replace />} />
        </Routes>
    );
};
